import { camelize } from 'humps'
import { useFormContext } from 'react-hook-form'

import { Input } from '~components/Chat/components'
import { getParseBodyParams, getType } from '~components/Chat/helpers'
import { PHONE_REGEX, REQUIRED_VALIDATION } from '~config'

type Props = {
  dialog: Stepper
  dialogType: ApiGetStepResponse['data'][0]['type']
  index: number
  setAnswers: (answer: string) => void
  handleAnswer: Function
}

const Phone = ({
  dialog,
  dialogType,
  index,
  setAnswers,
  handleAnswer,
}: Props) => {
  const { getValues } = useFormContext()

  const answer = getType(dialog, 'phone')[0]
  const parsedBodyParam = getParseBodyParams(answer)
  const id = Object.keys(parsedBodyParam)[0]

  const handleTextInputValue = (answer: Answer, id: string) => {
    const value = getValues(camelize(id))
    setAnswers(value)
    handleAnswer(answer.action, { [`${id}`]: value })
  }

  return (
    <Input
      key={dialogType + index}
      id={id}
      placeholder={answer.label}
      onSubmit={() => handleTextInputValue(answer, id)}
      validator={{
        ...REQUIRED_VALIDATION,
        pattern: {
          value: PHONE_REGEX,
          message: 'Le numéro de téléphone doit être valide',
        },
      }}
    />
  )
}

export default Phone
